import { SMLRouteParts, SMLRoutes } from '../../routing/sml/SMLRoutes';

const KEY = 'music24SignupLanding';
let memoryLanding: SignupLanding | null = null;

/**
 * A signup intent of the website that also names the first page after the sign-up. `outreach`
 * (music24.com/pitch, the playlist finder) opens Outreach → Pitch (plan Task 5, Task 9).
 */
export type SignupLanding = 'outreach';

const LANDING_ROUTES: Record<SignupLanding, SMLRouteParts> = {
  outreach: SMLRoutes.outreach,
};

function parseLanding(value: string | null): SignupLanding | null {
  return value === 'outreach' ? value : null;
}

/** Keeps the landing of `?intent=` until the first page after the sign-up takes it. */
export function captureSignupLanding(search: string = window.location.search): void {
  const landing = parseLanding(new URLSearchParams(search).get('intent'));
  if (landing === null) {
    return;
  }
  memoryLanding = landing;
  try {
    sessionStorage.setItem(KEY, landing);
  } catch {
    // Blocked storage: the memory copy lasts for this page view.
  }
}

/**
 * The route to open instead of Home, once: the call clears the landing. Null when none waits.
 */
export function takeSignupLandingRoute(): SMLRouteParts | null {
  let landing = memoryLanding;
  try {
    landing = parseLanding(sessionStorage.getItem(KEY)) ?? landing;
    sessionStorage.removeItem(KEY);
  } catch {
    // The memory copy decides.
  }
  memoryLanding = null;
  return landing === null ? null : LANDING_ROUTES[landing];
}
